import {useSelector} from 'react-redux'
import {getIsCheckInAtLeastTwoDaysAway} from 'modules/search/selectors'
import {getIsPrimaryOfferSplitBookingForPriceInsights} from 'modules/searchApi/selectors'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'

// Mobile Price Insights eligibility (formerly an A/B experiment).
//   - isMobile: mobile-only. `usePriceTrend` is shared with desktop and feeds
//     this into the price classifier; desktop must stay on the median
//     classifier, so keep it false there.
//   - isHydrated: avoid rendering pre-hydration for RSP-bound users.
//   - check-in ≥ 2 days: short-lead-time users are excluded.
//   - not a split booking: PriceTrend doesn't support split bookings.
export const usePriceInsightsEligibility = () => {
  const {isMobile} = useDeviceLayout()
  const isHydrated = useIsHydrated()
  const isCheckInAtLeastTwoDaysAway = useSelector(
    getIsCheckInAtLeastTwoDaysAway
  )
  const isPrimaryOfferSplitBooking = useSelector(
    getIsPrimaryOfferSplitBookingForPriceInsights
  )

  const isPriceInsightsEligible =
    isMobile &&
    isHydrated &&
    isCheckInAtLeastTwoDaysAway &&
    !isPrimaryOfferSplitBooking

  return {isPriceInsightsEligible}
}
